import React from "react";
import Navigation from "../Navigation";
import Header from "../Header";
import Footer from "../Footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

const Eula = () => (
  <div>
    <Navigation />
    <Header>
      <div className="heading text-uppercase">End-User License Agreement</div>
    </Header>
    <section className="page-section" id="eula">
      <Container>
        <Row>
          <Col lg="12" className="text-left legal-content">
            <h2 className="section-heading text-uppercase text-center">End-User License Agreement (EULA)</h2>
            <p className="text-muted text-center">
              <strong>Qvirt Labs Inc.</strong> — Effective Date: February 8, 2026 — Last Updated: February 8, 2026
            </p>
            <p>
              This End-User License Agreement ("Agreement") is a legal agreement between you ("User," "you," or "your") and Qvirt Labs Inc. ("Qvirt," "we," "us," or "our") governing your use of the QvirtAdmin application and related services (collectively, the "Service").
            </p>
            <p>
              By accessing or using the Service, you agree to be bound by this Agreement. If you do not agree, do not use the Service.
            </p>

            <h3>1. License Grant</h3>
            <p>Subject to the terms of this Agreement, Qvirt grants you a limited, non-exclusive, non-transferable, revocable license to use the Service for your internal business purposes.</p>

            <h3>2. Restrictions</h3>
            <p>You agree not to:</p>
            <ul>
              <li>Copy, modify, distribute, sell, lease, or sublicense the Service or any part thereof.</li>
              <li>Reverse engineer, decompile, or disassemble the Service, except as permitted by applicable law.</li>
              <li>Use the Service for any unlawful purpose or in violation of any applicable law or regulation.</li>
              <li>Attempt to gain unauthorized access to any systems or networks connected to the Service.</li>
              <li>Use the Service to store or transmit malicious code.</li>
              <li>Remove or alter any proprietary notices, labels, or marks on the Service.</li>
              <li>Use the Service in a manner that could damage, disable, or impair the Service or interfere with any other party's use.</li>
            </ul>

            <h3>3. Third-Party Integrations</h3>

            <h4>3.1 QuickBooks Online</h4>
            <p>
              The Service integrates with Intuit QuickBooks Online ("QBO"). Your use of QBO is subject to Intuit's terms of service and privacy policy. By connecting your QBO account, you authorize the Service to access and modify your QBO data as necessary to perform the functions you direct. You may revoke this authorization at any time through your Intuit account settings.
            </p>
            <p>You acknowledge that:</p>
            <ul>
              <li>Qvirt is not affiliated with, endorsed by, or sponsored by Intuit Inc.</li>
              <li>Intuit is not responsible for the Service or any actions taken through it.</li>
              <li>Any issues arising from the Service's interaction with QBO should be directed to Qvirt, not Intuit.</li>
            </ul>

            <h4>3.2 Google Sheets</h4>
            <p>
              The Service integrates with Google Sheets. Your use of Google Sheets is subject to Google's terms of service and privacy policy. By connecting your Google account, you authorize the Service to access spreadsheet data you designate. You may revoke this authorization at any time through your Google account settings.
            </p>

            <h3>4. Data and Privacy</h3>
            <p>
              Your use of the Service is also governed by our Privacy Policy, available at <a href="/privacy">https://qvirt.com/privacy</a>. By using the Service, you consent to the collection, use, and disclosure of your information as described in the Privacy Policy.
            </p>

            <h3>5. Intellectual Property</h3>
            <p>The Service, including all software, content, designs, and documentation, is the property of Qvirt Labs Inc. and is protected by Canadian and international intellectual property laws. This Agreement does not grant you any ownership rights in the Service.</p>

            <h3>6. User Responsibilities</h3>
            <p>You are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials and API tokens.</li>
              <li>All activity that occurs under your account.</li>
              <li>Ensuring that your use of the Service complies with all applicable laws, including British Columbia and Canadian privacy legislation.</li>
              <li>The accuracy and legality of any data you input or manage through the Service.</li>
              <li>Maintaining your own backups of data.</li>
            </ul>

            <h3>7. Disclaimer of Warranties</h3>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
            <p>
              QVIRT DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE, OR THAT ANY DEFECTS WILL BE CORRECTED. QVIRT DOES NOT WARRANT THE ACCURACY OR COMPLETENESS OF ANY DATA PROCESSED THROUGH THE SERVICE.
            </p>

            <h3>8. Limitation of Liability</h3>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL QVIRT LABS INC., ITS DIRECTORS, OFFICERS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, BUSINESS OPPORTUNITIES, OR GOODWILL, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY, EVEN IF QVIRT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p>
              QVIRT'S TOTAL AGGREGATE LIABILITY FOR ALL CLAIMS ARISING OUT OF OR RELATED TO THIS AGREEMENT SHALL NOT EXCEED THE AMOUNT YOU PAID TO QVIRT FOR THE SERVICE IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM, OR ONE HUNDRED CANADIAN DOLLARS (CAD $100), WHICHEVER IS GREATER.
            </p>

            <h3>9. Indemnification</h3>
            <p>
              You agree to indemnify, defend, and hold harmless Qvirt Labs Inc. and its directors, officers, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including reasonable legal fees) arising out of or in connection with: (a) your use of the Service; (b) your violation of this Agreement; or (c) your violation of any applicable law or the rights of any third party.
            </p>

            <h3>10. Term and Termination</h3>

            <h4>10.1 Term</h4>
            <p>This Agreement is effective from the date you first access or use the Service and continues until terminated.</p>

            <h4>10.2 Termination by You</h4>
            <p>You may terminate this Agreement at any time by ceasing to use the Service and revoking any third-party authorizations (Intuit, Google) connected through the Service.</p>

            <h4>10.3 Termination by Qvirt</h4>
            <p>We may suspend or terminate your access to the Service at any time, with or without cause, upon notice to you.</p>

            <h4>10.4 Effect of Termination</h4>
            <p>Upon termination, your license to use the Service ceases immediately. We will delete any stored tokens and cease accessing your third-party accounts. Sections 5, 7, 8, 9, 11, and 12 survive termination.</p>

            <h3>11. Governing Law and Dispute Resolution</h3>
            <p>This Agreement is governed by and construed in accordance with the laws of the Province of British Columbia and the federal laws of Canada applicable therein, without regard to conflict of law principles.</p>
            <p>Any dispute arising out of or in connection with this Agreement shall be submitted to the exclusive jurisdiction of the courts of British Columbia, sitting in Vancouver.</p>

            <h3>12. General Provisions</h3>

            <h4>12.1 Entire Agreement</h4>
            <p>This Agreement, together with the Privacy Policy, constitutes the entire agreement between you and Qvirt regarding the Service and supersedes all prior agreements and understandings.</p>

            <h4>12.2 Severability</h4>
            <p>If any provision of this Agreement is held to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.</p>

            <h4>12.3 Waiver</h4>
            <p>The failure of Qvirt to enforce any right or provision of this Agreement shall not constitute a waiver of that right or provision.</p>

            <h4>12.4 Assignment</h4>
            <p>You may not assign or transfer this Agreement without Qvirt's prior written consent. Qvirt may assign this Agreement without restriction.</p>

            <h4>12.5 Amendments</h4>
            <p>Qvirt reserves the right to modify this Agreement at any time. We will notify you of material changes by posting the updated Agreement on our website. Your continued use of the Service after such changes constitutes acceptance of the modified Agreement.</p>

            <h3>13. Contact Us</h3>
            <p>If you have questions about this Agreement, contact:</p>
            <p>
              <strong>Qvirt Labs Inc.</strong><br />
              Email: <a href="mailto:derekja@qvirt.com">derekja@qvirt.com</a><br />
              Website: <a href="https://qvirt.com" target="_blank" rel="noopener noreferrer">https://qvirt.com</a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
    <Footer />
  </div>
);

export default Eula;
